define('modules/creatives/componentBased/views/columnSelector',["jQuery", "T1", "T1View", "T1ColumnSortable"], function ($, T1, T1View, ColumnSortable) {
  "use strict";

  var componentColumnSelector;
  componentColumnSelector = ColumnSortable.extend({});
  return componentColumnSelector;
});
